import type { WorkoutCard } from '../../lib/workoutCards';
import { ExerciseInfoCard } from './ExerciseInfoCard';
import { MediaCard } from './MediaCard';
import { CuesCard } from './CuesCard';
import { SetCard } from './SetCard';
import { RestCard } from './RestCard';

interface WorkoutCardRendererProps {
  card: WorkoutCard;
  isPlaying: boolean;
  ttsEnabled?: boolean;
  restTimerState?: number;
  onSetUpdate?: (field: 'weight' | 'repsDone' | 'notes', value: string) => void;
  onComplete?: () => void;
  onSkip?: () => void;
  onSkipExercise?: (reason?: string) => void;
  onOpenSwap?: () => void;
  onRestTimeUpdate?: (seconds: number) => void;
}

export function WorkoutCardRenderer({
  card,
  isPlaying,
  ttsEnabled = false,
  restTimerState,
  onSetUpdate,
  onComplete,
  onSkip,
  onSkipExercise,
  onOpenSwap,
  onRestTimeUpdate,
}: WorkoutCardRendererProps) {
  switch (card.type) {
    case 'exercise_info':
      return <ExerciseInfoCard card={card} onSkip={onSkipExercise} onSwap={onOpenSwap} />;

    case 'media':
      return <MediaCard card={card} />;

    case 'cues':
      return <CuesCard card={card} />;

    case 'set':
      return (
        <SetCard
          card={card}
          onUpdate={(field, value) => onSetUpdate?.(field, value)}
          onComplete={() => onComplete?.()}
        />
      );

    case 'rest':
      return (
        <RestCard
          card={card}
          isPlaying={isPlaying}
          ttsEnabled={ttsEnabled}
          remainingTime={restTimerState}
          onTimeUpdate={onRestTimeUpdate}
          onSkip={() => onSkip?.()}
        />
      );

    default:
      return null;
  }
}
